import bindEvent from '../../scripts/util/event/bindEvent';
import checkKey from '../../scripts/util/event/checkKey';
import isElement from '../../scripts/util/DOM/isElement';

const selectors = {
	menu: '.js-menu',
	open: '.js-open-menu',
	close: '.js-close-menu',
	shadow: '.js-shadow'
};

const classes = {
	active: 'menu_state_active',
	body: 'overflow-hidden'
};

const onClick = e => {
	const target = e.currentTarget;
	const menu = target.closest(selectors.menu);
	menu.classList.toggle(classes.active);
	document.body.classList.toggle(classes.body);
};

const close = e => {
	const target = e.target;
	const menu = target.closest(selectors.menu);
	menu.classList.remove(classes.active);
	document.body.classList.remove(classes.body);
};

const onKeyPress = e => {
	const menu = document.querySelector(`.${classes.active}`);
	if (checkKey(e) && menu !== null) {
		menu.classList.remove(classes.active);
		document.body.classList.remove(classes.body);
	}
};

const scrollToggle = () => {
	const active = document.querySelector('.' + classes.active);
	if (document.documentElement.clientWidth >= 1100 && isElement('.' + classes.active)) {
		active.classList.remove(classes.active);
		document.body.classList.remove(classes.body);
	}
};

const setHandlers = () => {
	bindEvent(selectors.open, 'click', onClick);
	bindEvent(selectors.close, 'click', onClick);
	bindEvent(selectors.shadow, 'click', close);
	bindEvent('window', 'resize', scrollToggle);
	document.addEventListener('keydown', onKeyPress);
};

const render = () => {
	if (isElement(selectors.menu)) {
		setHandlers();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/menu/index.js